import axios from 'axios'


export const login = (data)=>(dispatch)=>{
    dispatch({type:'LOADING_UI'});
    axios.post('/api/auth/login',data).then(response=>{
        window.location.href = '/dashboard'
        localStorage.setItem('token',response.data.data.token)
        axios.defaults.headers.common["Authorization"] = "token "+ localStorage.getItem("token");
        dispatch({type:'SET_AUTH',payload:true})
        dispatch({type:'UNLOADING_UI'});
    }).catch(error=>{
        dispatch({type:'ERROR_DATA',payload:error.response.data})
        dispatch({type:'UNLOADING_UI'});
    })
}

export const logoutUser =()=>(dispatch)=>{
    localStorage.removeItem('token')
    delete axios.defaults.headers.common['Authorization']
    dispatch({type:"SET_AUTH",payload:false})
}

export const addProfileData = (data)=>(dispatch)=>{
    axios.patch('/api/auth/profile',data).then(response=>{
       dispatch({type:'SUCCESS_DATA',payload:response.data})
    }).catch(error=>{
       dispatch({type:'ERROR_DATA',payload:error.response.data})
    })
}


export const getProfileData = ()=>(dispatch)=>{
    axios.get('/api/auth/profile').then(response=>{
       dispatch({type:'PROFILE_DATA',payload:response.data})
    }).catch(error=>{
       dispatch({type:'ERROR_DATA',payload:error.response.data})
    })
}